// src/components/NotFound.js
import React from 'react';
import { Container, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function NotFound({ fullSize, deniedAccess }) {
    const { t } = useTranslation()

    return (
        <Container
            maxWidth="sm"
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: fullSize ? '100vh' : '50vh',
                textAlign: 'center',
            }}
        >
            <img
                src={require("../assets/img/404.gif")} // Replace with the path to your GIF
                alt="Empty Box"
                style={{ width: fullSize ? '40%' : '30%' }}
            />
            <Typography variant="h4" component="h1" gutterBottom>
                {t(deniedAccess ? "accessDenied" : "nothingFound")}
            </Typography>
            <Typography variant="h6" component="p" gutterBottom>
                {t(deniedAccess ? "authOnly" : "nothingFoundMsg")}
            </Typography>
        </Container>
    );
}
